export default __webpack_public_path__ + "static/Texas-53e3b8bd01fa437833932b7c0ad41422.webp";